import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-comment.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-comment.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { APP_BASE_HREF } from "@angular/common";
import { AddCommentConstants } from "./add-comment.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AddCommentService } from "./service/add-comment.service";
import { GuidUtils } from "../../utils/guid-utils";
import { Subject, take } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { takeUntil } from "rxjs/operators";
import { UserInformationService } from "../../services/user/user-information.service";
import { StepService } from "../../../step/step.service";
import { AppConfig } from "../../../app.config";
let AddCommentComponent = class AddCommentComponent {
    baseHref;
    changeDetectionRef;
    modalService;
    stepService;
    userInformationService;
    aflaModuleStrategyService;
    appController;
    addCommentService;
    _destroy$ = new Subject();
    moduleId;
    jobId;
    commentName;
    componentType;
    currentStepName;
    currentLink;
    attachmentManagerAttachmentType;
    attachmentManagerTitle;
    linkToReplace;
    infoLabel = "";
    commentAdded = new EventEmitter();
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addCommentForm;
    businessUnitsEmptyMessage = AddCommentConstants.noBusinessUnitsConfigured;
    businessUnitLabel = AddCommentConstants.BUSINESS_UNIT_LABEL;
    commentTextLabel = AddCommentConstants.COMMENT_TEXT_LABEL;
    commentTextControl = AddCommentConstants.COMMENT_TEXT_CONTROL;
    businessUnits = [];
    selectedBusinessUnitFromDropdown;
    setSelectAttachmentRequired = false;
    application;
    applicationStatus = null;
    attachmentManagerFormControl = AddCommentConstants.ATT_MANAGER_CONTROL;
    commentType = AddCommentConstants.COMMENT_TYPE;
    attachments = [];
    description;
    userInformationSubscription;
    authUserDetails;
    titleLbl = AddCommentConstants.TITLE_LBL;
    cancelBtnLbl = SharedConstants.CANCEL_LABEL;
    saveBtnLbl = SharedConstants.SAVE_LABEL;
    commentFormGroupFg = AddCommentConstants.COMMENT_FORM_GROUP;
    saveCommentSubscription;
    constructor(baseHref, changeDetectionRef, modalService, stepService, userInformationService, aflaModuleStrategyService, appController, addCommentService) {
        this.baseHref = baseHref;
        this.changeDetectionRef = changeDetectionRef;
        this.modalService = modalService;
        this.stepService = stepService;
        this.userInformationService = userInformationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.addCommentService = addCommentService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.getBusinessUnits();
        this.getApplicantData();
        this.getAuthUserInformation();
    }
    onSelectBusinessUnitChanged() {
        if (this.selectedBusinessUnitFromDropdown === undefined) {
            this.appController.showMessage(AddCommentConstants.noBusinessUnitsConfigured, AlertType.Warning);
        }
    }
    markFormControlsAsTouched() {
        Object.keys(this.addCommentForm.controls).forEach((controlName) => {
            this.addCommentForm.get(controlName).markAsTouched();
        });
        this.changeDetectionRef.detectChanges();
    }
    initForm() {
        this.addCommentForm = new FormGroup({
            businessUnit: new FormControl(null, Validators.required),
            commentText: new FormControl(null, Validators.required),
            attachmentManager: new FormControl(null)
        });
    }
    getBusinessUnits() {
        const params = {
            $filter: `name eq 'BusinessUnit' and moduleId eq ${this.moduleId}`,
        };
        this.stepService.getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(this.currentStepName, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        response.forEach((lookupValue) => {
            if (lookupValue.name === "BusinessUnit") {
                this.businessUnits.push((JSON.parse(lookupValue.content)).value);
            }
            if (this.businessUnits.length < 1) {
                this.appController.showMessage(this.businessUnitsEmptyMessage, AlertType.Warning);
            }
        });
        this.changeDetectionRef.detectChanges();
    }
    getCommentText() {
        return this.addCommentForm.get(this.commentTextControl).value;
    }
    getAttachmentIds() {
        const commentAttachmentIdsObjects = [];
        this.attachments = [];
        this.description += "Attachments: ";
        if (this.addCommentForm.get(this.attachmentManagerFormControl).value) {
            if (this.addCommentForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.length > 0) {
                this.addCommentForm.get(this.attachmentManagerFormControl).value.attachmentList.attachmentList.forEach((attachment) => {
                    this.description += attachment.fileName + ";";
                    delete attachment.file;
                    this.attachments.push(attachment);
                    commentAttachmentIdsObjects.push({ id: attachment.id });
                });
            }
        }
        return commentAttachmentIdsObjects;
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobId} and moduleId eq ${this.moduleId}`,
            $expand: this.aflaModuleStrategyService.getSelectedApplicationSummaryExpand()
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (returnValue) => {
                this.application = returnValue.value[0];
                this.appController.getApplicationStatus(this.application.jobId).pipe(takeUntil(this._destroy$), take(1)).subscribe({
                    next: (statuses) => {
                        if (statuses.value.length > 0) {
                            this.applicationStatus = statuses[0];
                        }
                    },
                    error: (error => {
                        this.appController.handleServerErrorMessage("Get application status", error, CRUDOperation.Get);
                    })
                });
            },
            error: (error => {
                this.appController.handleServerErrorMessage("add-comment", error, CRUDOperation.Get);
            })
        });
    }
    onBtnCancelClicked() {
        this.modalService.close();
    }
    saveComment() {
        const comment = this.getCommentText();
        const emailAttachmentIdsObjects = this.getAttachmentIds();
        this.markFormControlsAsTouched();
        if (this.commentName === "") {
            this.commentName = "CaptureCommentInternal";
        }
        const params = {
            requestGuid: GuidUtils.MakeNew().guid,
            jobId: this.jobId,
            commentName: this.commentName,
            businessUnit: this.selectedBusinessUnitFromDropdown,
            comment,
            commentType: this.commentType,
            attachments: emailAttachmentIdsObjects,
            capturedBy: `${this.authUserDetails.firstName} ${this.authUserDetails.lastName}`
        };
        this.addCommentService.saveComment(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: () => {
                this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                this.modalService.close();
            }, error: (error) => {
                this.appController.handleServerErrorMessage(AddCommentConstants.ERROR_SAVING_COMMENT, error, CRUDOperation.Add);
            }
        });
    }
    getAuthUserInformation() {
        this.userInformationSubscription = this.userInformationService.$authenticatedUser.subscribe({
            next: (authUSer) => {
                this.authUserDetails = authUSer;
            }
        });
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: ChangeDetectorRef },
        { type: NgbActiveModal },
        { type: StepService },
        { type: UserInformationService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: AddCommentService }
    ];
    static propDecorators = {
        moduleId: [{ type: Input }],
        jobId: [{ type: Input }],
        commentName: [{ type: Input }],
        componentType: [{ type: Input }],
        currentStepName: [{ type: Input }],
        currentLink: [{ type: Input }],
        attachmentManagerAttachmentType: [{ type: Input }],
        attachmentManagerTitle: [{ type: Input }],
        linkToReplace: [{ type: Input }],
        infoLabel: [{ type: Input }],
        commentAdded: [{ type: Output }]
    };
};
AddCommentComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-add-comment",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AddCommentComponent);
export { AddCommentComponent };
